import { render, staticRenderFns } from "shared/modules/seo/seo-text/homepage-seo-text.html?vue&type=template&id=6c449d7c&"
import script from "./HomepageSeoTextContent.vue?vue&type=script&lang=js&"
export * from "./HomepageSeoTextContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports